import { Divider, Grid } from '@material-ui/core'
import React from 'react'
import AsterTypography from 'asterX-UI/Typography/AsterTypography'
import ChipStandard from 'asterX-UI/DataDisplay/ChipStandard'
import { GRAY_COLORS, PRIMARY_COLORS, SUCCESS_COLORS } from 'asterX-UI'
import CarImg from 'assets/img/car_placeholder.jpg'
import clsx from 'clsx'
import { FieldInfoNG } from 'asterX-UI/DataDisplay'
import moment from 'moment'
import { useDesktopStyles } from './work-list-estimate.styles'
import AsterButton from 'asterX-UI/Buttons/AsterButton'

export const SppWorkListEstimateCardDesktop = ({
  assessment,
  isLast,
  onClick,
  onClickPurchaser
}) => {
  const classes = useDesktopStyles()

  return (
    <Grid item container>
      <Grid item style={{ flexGrow: 1 }}>
        <Grid
          item
          container
          alignItems="center"
          spacing="3"
          style={{ marginBottom: 20 }}
        >
          <Grid item>
            <AsterTypography variant="h6">
              Оценка № {assessment.id}
            </AsterTypography>
          </Grid>
          <Grid item>
            <ChipStandard
              color={PRIMARY_COLORS[700]}
              backgroundColor={PRIMARY_COLORS[50]}
            >
              {assessment?.carStatusesName}
            </ChipStandard>
          </Grid>
        </Grid>
        <Grid item container style={{ marginTop: 'auto' }}>
          <Grid item>
            <img
              alt={assessment.id}
              width={127}
              height={100}
              style={{ borderRadius: 8, objectFit: 'cover' }}
              src={assessment?.coverPhoto ? assessment?.coverPhoto : CarImg}
            />
          </Grid>
          <Grid item style={{ marginLeft: 20, flexGrow: 1 }}>
            <Grid item xs="12" style={{ marginBottom: 20 }}>
              <AsterTypography variant="h6">
                {clsx(
                  assessment?.markaName,
                  assessment?.modelName,
                  assessment?.year
                )}
              </AsterTypography>
            </Grid>
            <Grid item container xs="12">
              <Grid item xs="4">
                <FieldInfoNG label="VIN-код" isVertical>
                  <AsterTypography>{assessment?.vin || '-'}</AsterTypography>
                </FieldInfoNG>
              </Grid>
              <Grid item xs="4">
                <FieldInfoNG label="Дата создания оценки" isVertical>
                  <AsterTypography>
                    {assessment?.createdDate
                      ? moment(assessment?.createdDate).format('DD MMM YYYY')
                      : '-'}
                  </AsterTypography>
                </FieldInfoNG>
              </Grid>
              <Grid item xs="4">
                <FieldInfoNG label="ФИО закупщика" isVertical>
                  <AsterTypography
                    onClick={() => onClickPurchaser(assessment)}
                    style={{
                      textDecoration: assessment?.assignToFullName
                        ? 'underline'
                        : 'none',
                      cursor: 'pointer'
                    }}
                  >
                    {assessment?.assignToFullName || '-'}
                  </AsterTypography>
                </FieldInfoNG>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item style={{ display: 'flex', flexDirection: 'column' }}>
        <Grid item className={classes.priceBlock}>
          <FieldInfoNG
            label={'Первичная оценка'}
            isVertical
            rootStyle={{
              width: '49%'
            }}
            labelStyle={{ color: GRAY_COLORS[700] }}
            style={{
              color: SUCCESS_COLORS[600],
              fontSize: 18,
              fontWeight: 500
            }}
          >
            {assessment?.initialPrice
              ? `${assessment?.initialPrice?.toString()?.thousandSeparator()} ₸`
              : '-'}
          </FieldInfoNG>
          <FieldInfoNG
            label={'Ожидания клиента'}
            isVertical
            rootStyle={{
              width: '49%'
            }}
            labelStyle={{ color: GRAY_COLORS[700] }}
            style={{
              fontSize: 18,
              fontWeight: 500
            }}
          >
            {assessment?.clientExpectation
              ? `${assessment?.clientExpectation
                  ?.toString()
                  ?.thousandSeparator()} ₸`
              : '-'}
          </FieldInfoNG>
        </Grid>

        <Grid
          item
          container
          justifyContent="flex-end"
          style={{ marginTop: 'auto' }}
        >
          <AsterButton color="primary" onClick={() => onClick(assessment)}>
            Результат оценки
          </AsterButton>
        </Grid>
      </Grid>
      <Grid item xs="12">
        {!isLast && (
          <Divider
            style={{
              marginTop: 20,
              marginBottom: 24
            }}
          />
        )}
      </Grid>
    </Grid>
  )
}
